<template>
    <div class="home-screen">
        <HeaderLogo />
        <div class="home__nav-list">
            <div
                :class="[
                    'home__nav-item',
                    { 'h-auto': v.hasBanner },
                    v.col ? `column-sm-${v.col}` : '',
                    v.lgCol ? `column-lg-${v.lgCol}` : '',
                    v.hasIcon ? v.name : '',
                ]"
                v-for="(v, i) in $store.state.config.features"
                :key="i"
            >
                <div class="home__nav-item-link" @click="navigateMenu(v.routing)">
                    <NavIcon v-if="v.hasIcon" :name="v.name" :icon="v.icon" />
                    <NavImage v-if="v.hasBanner" :img="v.name" :label="v.label" />
                </div>
            </div>
        </div>
        <FooterButton />
    </div>
</template>
<script>
import HeaderLogo from '@/components/home/header/header-logo.vue';
import NavIcon from '@/components/home/nav/nav-icon.vue';
import NavImage from '@/components/home/nav/nav-img.vue';
import FooterButton from '@/components/home/footer/button.vue';
import EventBus from '@/utils/EventBus';

export default {
    components: { NavIcon, NavImage, HeaderLogo, FooterButton },
    data() {
        return {};
    },
    created() {
        this.fetchData();
        window.addEventListener('resize', this.fetchData);
    },

    methods: {
        fetchData() {
            const { config, isScreenMobile } = this.$store.state;
            let data = config?.features;
            if (!isScreenMobile) {
                return data.sort((a, b) => a.lgOrder - b.lgOrder);
            }
            return data;
        },
        navigateMenu(url) {
            const query = this.$route.query;

            parent.postMessage({ command: 'is-show-camera', param: false }, '*');
            EventBus.emit('on-hide-camera-scan');

            this.$router.push({ path: url, query });
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/home.scss';
</style>
